

import React, { Component } from 'react'
import { Link, withRouter } from 'react-router-dom'
import { Collapse } from 'react-bootstrap'
import { Trans } from 'react-i18next'
// axios, useEffect, useState, Dropdown are imported but not used in the class component, so they are kept but can be removed if not needed elsewhere.
import axios from 'axios'
import { useEffect, useState } from 'react'
import { Dropdown } from 'react-bootstrap'

class Sidebar extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  toggleMenuState(menuState) {
    // Standard logic to open/close menu item, closing others
    if (this.state[menuState]) {
      this.setState({ [menuState]: false })
    } else if (Object.keys(this.state).length === 0) {
      this.setState({ [menuState]: true })
    } else {
      // Close all menus first
      Object.keys(this.state).forEach((i) => {
        this.setState({ [i]: false })
      })
      // Open the target menu
      this.setState({ [menuState]: true })
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.onRouteChanged()
    }
  }

  // Helper function to check if a path is active
  isPathActive(path) {
    return this.props.location.pathname.startsWith(path)
  }

  // NEW/MODIFIED logic to specifically handle which menu opens
  onRouteChanged() {
    document.querySelector('#sidebar').classList.remove('active')

    // Reset all menu states
    Object.keys(this.state).forEach((i) => {
      this.setState({ [i]: false })
    })

    const currentPath = this.props.location.pathname

    // Define the main dropdown paths and their states
    const dropdownPaths = [
      { path: '/admin', state: 'adminMenu' },
      { path: '/game', state: 'gameMenu' },
      { path: '/user', state: 'userMenu' },
      { path: '/agent', state: 'agentMenu' },
      { path: '/challenge', state: 'challengeMenu' },
      { path: '/Reports', state: 'reportsMenu' },
      // The old transaction and deposit paths are removed from this general loop
      // to handle their overlapping paths specifically below.
    ]

    dropdownPaths.forEach((obj) => {
      if (this.isPathActive(obj.path)) {
        this.setState({ [obj.state]: true })
      }
    })

    // --- FIX FOR DEPOSIT MANAGER AND TRANSACTION MANAGER CONFLICT ---

    // 1. Check for Deposit Manager sub-paths
    // Since all deposit manager paths start with /transaction, we need to check them first.
    // I've grouped the deposit-related sub-paths.
    const depositSubPaths = [
      '/transaction/transaction_history',
      '/transaction/deposit_manual',
      '/transaction/deposit_g_history',
      '/transaction/deposit_reject',
    ]

    if (depositSubPaths.some(path => currentPath.startsWith(path))) {
      this.setState({ depositMenu: true })
      // Crucial: If a deposit sub-path is active, we MUST NOT activate the main transaction menu.
      this.setState({ transactionMenu: false })
      return; // Exit the function after setting the correct menu.
    }

    // 2. Check for Transaction Manager sub-paths
    // These paths should not conflict with the deposit paths now.
    const transactionSubPaths = [
      '/transaction/penaltybonus',
      '/transaction/penaltyadd',
      '/transaction/withdraw',
      '/transaction/allwithdrawl',
      '/transaction/rejectwithdraw',
    ]

    if (transactionSubPaths.some(path => currentPath.startsWith(path))) {
      this.setState({ transactionMenu: true })
      this.setState({ depositMenu: false }) // Ensure deposit menu is closed
      return;
    }
    
    // Fallback: If neither specific set is active, but the route is '/transaction' exactly
    if (currentPath === '/transaction') {
        // You might decide which menu opens by default, or none. 
        // For safety, let's keep both closed if it's just the base path without a sub-route.
        this.setState({ depositMenu: false, transactionMenu: false });
    }
    // Note: If you want one to open if on the base path, you can set it here.
  }

  // Existing check for active state on individual list items (li)
  isSubPathActive(path) {
    return this.props.location.pathname === path
  }

  render() {
    // ... (rest of your render logic remains mostly the same)
    // Removed unused variables (appURL, logo) for cleaner code.

    return (
      <nav className="sidebar sidebar-offcanvas" id="sidebar">
        <div className="sidebar-brand-wrapper d-none d-lg-flex align-items-center justify-content-center fixed-top">
          <a className="brand-logo" href="/dashboard"></a>
          <div className="ADMIN_PANEL_heading">
            <h3>Admin Panel</h3>
          </div>
        </div>
        <ul className="nav">
          <li className="nav-item profile">
            <div className="profile-desc">
              <div className="profile-pic">
                <div className="count-indicator">
                  <img
                    className="img-xs rounded-circle "
                    src="https://cdn-icons-png.flaticon.com/512/2206/2206368.png"
                    alt="profile"
                  />
                  <span className="count bg-success"></span>
                </div>
                <div className="profile-name">
                  <h5 className="mb-0 font-weight-normal">
                    <Trans>User: {this.props.usertype}</Trans>
                  </h5>
                </div>
              </div>
            </div>
          </li>
          <li className="nav-item nav-category">
            <span className="nav-link">
              <Trans>Navigation</Trans>
            </span>
          </li>
          {/* Dashboard */}
          {this.props.dashboard && (
            <li
              className={
                this.isPathActive('/dashboard') && this.props.location.pathname === '/dashboard'
                  ? 'nav-item menu-items active'
                  : 'nav-item menu-items'
              }
            >
              <Link className="nav-link" to="/dashboard">
                <span className="menu-icon">
                  <i className="mdi mdi-speedometer"></i>
                </span>
                <span className="menu-title">
                  <Trans>Dashboard</Trans>
                </span>
              </Link>
            </li>
          )}
          {/* Admin Earnings */}
          {this.props.earnings && (
            <li
              className={
                this.isPathActive('/earinigs')
                  ? 'nav-item menu-items active'
                  : 'nav-item menu-items'
              }
            >
              <Link className="nav-link" to="/earinigs">
                <span className="menu-icon">
                  <i className="mdi mdi-cash-usd"></i>
                </span>
                <span className="menu-title">
                  <Trans> Admin Earnings</Trans>
                </span>
              </Link>
            </li>
          )}
          {/* Admin Manager */}
          {(this.props.allAdmins ||
            this.props.newAdmin ||
            this.props.sitesettings) && (
              <li
                className={
                  this.isPathActive('/admin')
                    ? 'nav-item menu-items active'
                    : 'nav-item menu-items'
                }
              >
                <div
                  className={
                    this.state.adminMenu ? 'nav-link menu-expanded' : 'nav-link'
                  }
                  onClick={() => this.toggleMenuState('adminMenu')}
                  data-toggle="collapse"
                >
                  <span className="menu-icon">
                    <i className="mdi mdi-account-star"></i>
                  </span>
                  <span className="menu-title">
                    <Trans>Admin Manager</Trans>
                  </span>
                  <i className="menu-arrow"></i>
                </div>
                <Collapse in={this.state.adminMenu}>
                  <div>
                    <ul className="nav flex-column sub-menu">
                      {this.props.allAdmins && (
                        <li className="nav-item">
                          {' '}
                          <Link
                            className={
                              this.isSubPathActive('/admin/alladmins')
                                ? 'nav-link active'
                                : 'nav-link'
                            }
                            to="/admin/alladmins"
                          >
                            <Trans>All Admins</Trans>
                          </Link>
                        </li>
                      )}
                      {this.props.newAdmin && (
                        <li className="nav-item">
                          {' '}
                          <Link
                            className={
                              this.isSubPathActive('/admin/addadmin')
                                ? 'nav-link active'
                                : 'nav-link'
                            }
                            to="/admin/addadmin"
                          >
                            <Trans>Add New Admin</Trans>
                          </Link>
                        </li>
                      )}
                      {this.props.allAdmins && (
                        <li className="nav-item">
                          {' '}
                          <Link
                            className={
                              this.isSubPathActive('/payment-manage')
                                ? 'nav-link active'
                                : 'nav-link'
                            }
                            to="/payment-manage"
                          >
                            <Trans>UPI Management</Trans>
                          </Link>
                        </li>
                      )}
                      {this.props.allAdmins && (
                        <li className="nav-item">
                          {' '}
                          <Link
                            className={
                              this.isSubPathActive('/admin/sitesettings')
                                ? 'nav-link active'
                                : 'nav-link'
                            }
                            to="/admin/sitesettings"
                          >
                            <Trans>Website Settings</Trans>
                          </Link>
                        </li>
                      )}
                    </ul>
                  </div>
                </Collapse>
              </li>
            )}
          {/* User Manager */}
          {(this.props.allUsers ||
            this.props.newUser ||
            this.props.pendingKyc ||
            this.props.completedKyc ||
            this.props.rejectKyc) && (
              <li
                className={
                  this.isPathActive('/user')
                    ? 'nav-item menu-items active'
                    : 'nav-item menu-items'
                }
              >
                <div
                  className={
                    this.state.userMenu ? 'nav-link menu-expanded' : 'nav-link'
                  }
                  onClick={() => this.toggleMenuState('userMenu')}
                  data-toggle="collapse"
                >
                  <span className="menu-icon">
                    <i className="mdi mdi-face"></i>
                  </span>
                  <span className="menu-title">
                    <Trans>User Manager</Trans>
                  </span>
                  <i className="menu-arrow"></i>
                </div>
                <Collapse in={this.state.userMenu}>
                  <div>
                    <ul className="nav flex-column sub-menu">
                      {this.props.allUsers && (
                        <li className="nav-item">
                          {' '}
                          <Link
                            className={
                              this.isSubPathActive('/user/allusers')
                                ? 'nav-link active'
                                : 'nav-link'
                            }
                            to="/user/allusers"
                          >
                            <Trans>View All Users</Trans>
                          </Link>
                        </li>
                      )}

                      {this.props.pendingKyc && (
                        <li className="nav-item">
                          {' '}
                          <Link
                            className={
                              this.isSubPathActive('/user/UserKyc')
                                ? 'nav-link active'
                                : 'nav-link'
                            }
                            to="/user/UserKyc"
                          >
                            <Trans>Pending Kyc</Trans>
                          </Link>
                        </li>
                      )}
                      {this.props.completedKyc && (
                        <li className="nav-item">
                          {' '}
                          <Link
                            className={
                              this.isSubPathActive('/user/kyc')
                                ? 'nav-link active'
                                : 'nav-link'
                            }
                            to="/user/kyc"
                          >
                            <Trans>Completed Kyc</Trans>
                          </Link>
                        </li>
                      )}
                      {this.props.rejectKyc && (
                        <li className="nav-item">
                          {' '}
                          <Link
                            className={
                              this.isSubPathActive('/user/reject')
                                ? 'nav-link active'
                                : 'nav-link'
                            }
                            to="/user/reject"
                          >
                            <Trans>Reject Kyc</Trans>
                          </Link>
                        </li>
                      )}
                    </ul>
                  </div>
                </Collapse>
              </li>
            )}
          {/* Challenge Manager */}
          {(this.props.allChallenges ||
            this.props.completedChallenges ||
            this.props.conflictChallenges ||
            this.props.cancelledChallenges ||
            this.props.runningChallenges ||
            this.props.newChallenge) && (
              <li
                className={
                  this.isPathActive('/challenge')
                    ? 'nav-item menu-items active'
                    : 'nav-item menu-items'
                }
              >
                <div
                  className={
                    this.state.challengeMenu
                      ? 'nav-link menu-expanded'
                      : 'nav-link'
                  }
                  onClick={() => this.toggleMenuState('challengeMenu')}
                  data-toggle="collapse"
                >
                  <span className="menu-icon">
                    <i className="mdi mdi-xbox-controller"></i>
                  </span>
                  <span className="menu-title">
                    <Trans>Challenge Manager</Trans>
                  </span>
                  <i className="menu-arrow"></i>
                </div>
                <Collapse in={this.state.challengeMenu}>
                  <div>
                    <ul className="nav flex-column sub-menu">
                      {this.props.allChallenges && (
                        <li className="nav-item">
                          {' '}
                          <Link
                            className={
                              this.isSubPathActive('/challenge/allchallenges')
                                ? 'nav-link active'
                                : 'nav-link'
                            }
                            to="/challenge/allchallenges"
                          >
                            <Trans>View All Challenge</Trans>
                          </Link>
                        </li>
                      )}
                      {this.props.completedChallenges && (
                        <li className="nav-item">
                          {' '}
                          <Link
                            className={
                              this.isSubPathActive('/challenge/completed_challange')
                                ? 'nav-link active'
                                : 'nav-link'
                            }
                            to="/challenge/completed_challange"
                          >
                            <Trans>Completed Challenge</Trans>
                          </Link>
                        </li>
                      )}
                      {this.props.conflictChallenges && (
                        <li className="nav-item">
                          {' '}
                          <Link
                            className={
                              this.isSubPathActive('/challenge/pending_challange')
                                ? 'nav-link active'
                                : 'nav-link'
                            }
                            to="/challenge/pending_challange"
                          >
                            <Trans>Pending Challenge</Trans>
                          </Link>
                        </li>
                      )}
                      {this.props.conflictChallenges && (
                        <li className="nav-item">
                          {' '}
                          <Link
                            className={
                              this.isSubPathActive('/challenge/conflict_challange')
                                ? 'nav-link active'
                                : 'nav-link'
                            }
                            to="/challenge/conflict_challange"
                          >
                            <Trans>Conflict Challenge</Trans>
                          </Link>
                        </li>
                      )}
                      {this.props.cancelledChallenges && (
                        <li className="nav-item">
                          {' '}
                          <Link
                            className={
                              this.isSubPathActive('/challenge/cancelled_challange')
                                ? 'nav-link active'
                                : 'nav-link'
                            }
                            to="/challenge/cancelled_challange"
                          >
                            <Trans>Cancelled Challenge</Trans>
                          </Link>
                        </li>
                      )}
                      {this.props.runningChallenges && (
                        <li className="nav-item">
                          {' '}
                          <Link
                            className={
                              this.isSubPathActive('/challenge/running_challange')
                                ? 'nav-link active'
                                : 'nav-link'
                            }
                            to="/challenge/running_challange"
                          >
                            <Trans>Running Challenge</Trans>
                          </Link>
                        </li>
                      )}
                      {this.props.newChallenge && (
                        <li className="nav-item">
                          {' '}
                          <Link
                            className={
                              this.isSubPathActive('/challenge/new_challange')
                                ? 'nav-link active'
                                : 'nav-link'
                            }
                            to="/challenge/new_challange"
                          >
                            <Trans>New Challenge</Trans>
                          </Link>
                        </li>
                      )}
                    </ul>
                  </div>
                </Collapse>
              </li>
            )}

          {/* Deposit Manager - NEW LOGIC APPLIED HERE */}
          {(this.props.depositHistory || this.props.depositManual) && (
            <li
              className={
                this.state.depositMenu
                  ? 'nav-item menu-items active' // Use state to determine main menu active state
                  : 'nav-item menu-items'
              }
            >
              <div
                className={
                  this.state.depositMenu
                    ? 'nav-link menu-expanded'
                    : 'nav-link'
                }
                onClick={() => this.toggleMenuState('depositMenu')}
                data-toggle="collapse"
              >
                <span className="menu-icon">
                  <i className="mdi mdi-bank"></i>
                </span>
                <span className="menu-title">
                  <Trans>Deposit Manager</Trans>
                </span>
                <i className="menu-arrow"></i>
              </div>

              <Collapse in={this.state.depositMenu}>
                <div>
                  <ul className="nav flex-column sub-menu">
                    {this.props.depositHistory && (

                      <li className="nav-item">
                        {' '}
                        <Link
                          className={
                            this.isSubPathActive(
                              '/transaction/transaction_history',
                            )
                              ? 'nav-link active'
                              : 'nav-link'
                          }
                          to="/transaction/transaction_history"
                        >
                          <Trans>Deposit manual success</Trans>
                        </Link>
                      </li>
                    )}

                    <li className="nav-item">
                      {' '}
                      <Link
                        className={
                          this.isSubPathActive(
                            '/transaction/deposit_manual',
                          )
                            ? 'nav-link active'
                            : 'nav-link'
                        }
                        to="/transaction/deposit_manual"
                      >
                        <Trans>Deposit Manual</Trans>
                      </Link>
                    </li>
                    <li className="nav-item">
                      {' '}
                      <Link
                        className={
                          this.isSubPathActive(
                            '/transaction/deposit_g_history',
                          )
                            ? 'nav-link active'
                            : 'nav-link'
                        }
                        to="/transaction/deposit_g_history"
                      >
                        <Trans>Deposit Gateway History</Trans>
                      </Link>
                    </li>
                    <li className="nav-item">
                      {' '}
                      <Link
                        className={
                          this.isSubPathActive(
                            '/transaction/deposit_reject',
                          )
                            ? 'nav-link active'
                            : 'nav-link'
                        }
                        to="/transaction/deposit_reject"
                      >
                        <Trans>Deposit Reject</Trans>
                      </Link>
                    </li>
                    <li className="nav-item">
                      {' '}
                      <Link
                        className={
                          this.isSubPathActive(
                            '/transaction/perdayrecord',
                          )
                            ? 'nav-link active'
                            : 'nav-link'
                        }
                        to="/transaction/perdayrecord"
                      >
                        <Trans>Per Day Record</Trans>
                      </Link>
                    </li>
                  </ul>
                </div>
              </Collapse>
            </li>
          )}

          {/* Transaction Manager - NEW LOGIC APPLIED HERE */}
          {(this.props.penaltyBonus ||
            this.props.withdrawlHistory ||
            this.props.allWithdrawlRequests) && ( // Removed deposit props from here
              <li
                className={
                  this.state.transactionMenu
                    ? 'nav-item menu-items active' // Use state to determine main menu active state
                    : 'nav-item menu-items'
                }
              >
                <div
                  className={
                    this.state.transactionMenu
                      ? 'nav-link menu-expanded'
                      : 'nav-link'
                  }
                  onClick={() => this.toggleMenuState('transactionMenu')}
                  data-toggle="collapse"
                >
                  <span className="menu-icon">
                    <i className="mdi mdi-transit-transfer"></i>
                  </span>
                  <span className="menu-title">
                    <Trans>Transaction Manager</Trans>
                  </span>
                  <i className="menu-arrow"></i>
                </div>
                <Collapse in={this.state.transactionMenu}>
                  <div>
                    <ul className="nav flex-column sub-menu">
                      {this.props.penaltyBonus && (
                        <li className="nav-item">
                          {' '}
                          <Link
                            className={
                              this.isSubPathActive('/transaction/penaltybonus')
                                ? 'nav-link active'
                                : 'nav-link'
                            }
                            to="/transaction/penaltybonus"
                          >
                            <Trans> Bonus Add</Trans>
                          </Link>
                        </li>
                      )}
                      {this.props.penaltyBonus && (
                        <li className="nav-item">
                          {' '}
                          <Link
                            className={
                              this.isSubPathActive('/transaction/penaltyadd')
                                ? 'nav-link active'
                                : 'nav-link'
                            }
                            to="/transaction/penaltyadd"
                          >
                            <Trans>Penlty Add</Trans>
                          </Link>
                        </li>
                      )}

                      {this.props.withdrawlHistory && (
                        <li className="nav-item">
                          {' '}
                          <Link
                            className={
                              this.isSubPathActive('/transaction/withdraw')
                                ? 'nav-link active'
                                : 'nav-link'
                            }
                            to="/transaction/withdraw"
                          >
                            <Trans>Withdrawl history</Trans>
                          </Link>
                        </li>
                      )}
                      {this.props.allWithdrawlRequests && (
                        <li className="nav-item">
                          {' '}
                          <Link
                            className={
                              this.isSubPathActive('/transaction/allwithdrawl')
                                ? 'nav-link active'
                                : 'nav-link'
                            }
                            to="/transaction/allwithdrawl"
                          >
                            <Trans>View All Withdrawl Request</Trans>
                          </Link>
                        </li>
                      )}
                      {this.props && (
                        <li className="nav-item">
                          {' '}
                          <Link
                            className={
                              this.isSubPathActive('/transaction/rejectwithdraw')
                                ? 'nav-link active'
                                : 'nav-link'
                            }
                            to="/transaction/rejectwithdraw"
                          >
                            <Trans> RejectWithdraw Request</Trans>
                          </Link>
                        </li>
                      )}
                    </ul>
                  </div>
                </Collapse>
              </li>
            )}

          {/* Reports */}
          {(this.props.bonusReport ||
            this.props.depositReport ||
            this.props.penaltyReport ||
            this.props.withdrawlReport) && (
              <li
                className={
                  this.isPathActive('/Reports')
                    ? 'nav-item menu-items active'
                    : 'nav-item menu-items'
                }
              >
                <div
                  className={
                    this.state.reportsMenu ? 'nav-link menu-expanded' : 'nav-link'
                  }
                  onClick={() => this.toggleMenuState('reportsMenu')}
                  data-toggle="collapse"
                >
                  <span className="menu-icon">
                    <i className="mdi mdi-poll-box"></i>
                  </span>
                  <span className="menu-title">
                    <Trans>Reports</Trans>
                  </span>
                  <i className="menu-arrow"></i>
                </div>
                <Collapse in={this.state.reportsMenu}>
                  <div>
                    <ul className="nav flex-column sub-menu">
                      {this.props.bonusReport && (
                        <li className="nav-item">
                          {' '}
                          <Link
                            className={
                              this.isSubPathActive('/Reports/bonusReport')
                                ? 'nav-link active'
                                : 'nav-link'
                            }
                            to="/Reports/bonusReport"
                          >
                            <Trans>bonus Report</Trans>
                          </Link>
                        </li>
                      )}
                      {this.props.penaltyReport && (
                        <li className="nav-item">
                          {' '}
                          <Link
                            className={
                              this.isSubPathActive('/Reports/penaltyReport')
                                ? 'nav-link active'
                                : 'nav-link'
                            }
                            to="/Reports/penaltyReport"
                          >
                            <Trans>penalty Report</Trans>
                          </Link>
                        </li>
                      )}
                      {this.props.withdrawalReport && (
                        <li className="nav-item">
                          {' '}
                          <Link
                            className={
                              this.isSubPathActive('/Reports/withdrawalReport')
                                ? 'nav-link active'
                                : 'nav-link'
                            }
                            to="/Reports/withdrawalReport"
                          >
                            <Trans>withdrawal Report</Trans>
                          </Link>
                        </li>
                      )}
                    </ul>
                  </div>
                </Collapse>
              </li>
            )}
        </ul>
      </nav>
    )
  }

  // Modified isPathActive to only check the beginning of the path for menu open state
  isPathActive(path) {
    return this.props.location.pathname.startsWith(path)
  }

  // New helper for checking active state for a specific link/sub-path
  isSubPathActive(path) {
    return this.props.location.pathname === path
  }


  componentDidMount() {
    this.onRouteChanged()
    // add class 'hover-open' to sidebar navitem while hover in sidebar-icon-only menu
    const body = document.querySelector('body')
    document.querySelectorAll('.sidebar .nav-item').forEach((el) => {
      el.addEventListener('mouseover', function () {
        if (body.classList.contains('sidebar-icon-only')) {
          el.classList.add('hover-open')
        }
      })
      el.addEventListener('mouseout', function () {
        if (body.classList.contains('sidebar-icon-only')) {
          el.classList.remove('hover-open')
        }
      })
    })
  }
}

export default withRouter(Sidebar)